module.exports = __webpack_public_path__ + "components/star-rating/static/white/4-cb124fe20e5dfa2ca8f1e35c77b5a470.svg";